module.exports = __webpack_public_path__ + "img/stack06.3520ad76.svg";